export function isLocked({
  lockedUntil
}) {
  return lockedUntil > new Date().valueOf();
}
export function hasCancelledImporting({
  cancelled,
  importedArticleCount,
  postProcessedArticleCount,
  skippedArticleCount,
  totalArticleCount
}) {
  return cancelled && importedArticleCount + skippedArticleCount === totalArticleCount && postProcessedArticleCount === importedArticleCount;
}
export function hasSuccessfullyCompletedImporting({
  cancelled,
  importedArticleCount,
  postProcessedArticleCount
}) {
  return !cancelled && postProcessedArticleCount === importedArticleCount && importedArticleCount >= 0;
}
export function isImporting({
  importedArticleCount,
  lockedUntil,
  skippedArticleCount,
  totalArticleCount
}) {
  return isLocked({
    lockedUntil
  }) && importedArticleCount + skippedArticleCount < totalArticleCount;
}
export function isPostProcessing({
  importedArticleCount,
  lockedUntil,
  postProcessedArticleCount,
  skippedArticleCount,
  totalArticleCount
}) {
  return isLocked({
    lockedUntil
  }) && importedArticleCount + skippedArticleCount >= totalArticleCount && postProcessedArticleCount < importedArticleCount;
}
export function isScraping({
  lockedUntil,
  totalArticleCount
}) {
  return isLocked({
    lockedUntil
  }) && totalArticleCount === -1;
}